import { render, staticRenderFns } from "./ProviderAssignment.vue?vue&type=template&id=43bdfbb6&scoped=true&"
import script from "./ProviderAssignment.vue?vue&type=script&lang=js&"
export * from "./ProviderAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAssignment.vue?vue&type=style&index=0&id=43bdfbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bdfbb6",
  null
  
)

component.options.__file = "ProviderAssignment.vue"
export default component.exports